var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 42,
    viewBox: "0 0 270 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260 42H10C4.5025 42 0 39.6362 0 36.75V5.25C0 2.36381 4.5025 2.21967e-06 10 2.21967e-06H260C265.498 2.21967e-06 270 2.36381 270 5.25V36.75C270 39.6362 265.498 42 260 42Z",
    fill: "#040015"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.272 10.7572C113.272 11.6339 113.003 12.3361 112.473 12.8598C111.864 13.4806 111.071 13.793 110.099 13.793C109.17 13.793 108.377 13.4753 107.726 12.8493C107.074 12.214 106.749 11.4344 106.749 10.5012C106.749 9.56803 107.074 8.78841 107.726 8.15841C108.377 7.5271 109.17 7.20947 110.099 7.20947C110.561 7.20947 111.002 7.30266 111.423 7.47591C111.843 7.65047 112.184 7.88672 112.431 8.1781L111.869 8.73197C111.438 8.23454 110.85 7.9891 110.099 7.9891C109.422 7.9891 108.834 8.2201 108.335 8.68603C107.842 9.15328 107.595 9.75835 107.595 10.5012C107.595 11.2441 107.842 11.8544 108.335 12.3217C108.834 12.7823 109.422 13.0186 110.099 13.0186C110.818 13.0186 111.423 12.7823 111.9 12.3164C112.215 12.008 112.394 11.5827 112.441 11.0393H110.099V10.2807H113.223C113.261 10.4448 113.272 10.6036 113.272 10.7572Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.228 8.1256H115.294V10.1206H117.939V10.8792H115.294V12.8742H118.228V13.6473H114.463V7.35254H118.228V8.1256Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.726 13.6473H120.895V8.1256H119.095V7.35254H123.527V8.1256H121.726V13.6473Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.736 13.6473V7.35254H127.566V13.6473H126.736Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131.241 13.6473H130.417V8.1256H128.61V7.35254H133.048V8.1256H131.241V13.6473Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.438 12.8388C140.802 13.4753 140.015 13.793 139.075 13.793C138.13 13.793 137.342 13.4753 136.706 12.8388C136.072 12.2035 135.756 11.4239 135.756 10.5012C135.756 9.57853 136.072 8.79891 136.706 8.16366C137.342 7.5271 138.13 7.20947 139.075 7.20947C140.009 7.20947 140.797 7.5271 141.433 8.16891C142.073 8.80941 142.389 9.58379 142.389 10.5012C142.389 11.4239 142.073 12.2035 141.438 12.8388ZM137.321 12.3112C137.799 12.7823 138.381 13.0186 139.075 13.0186C139.763 13.0186 140.351 12.7823 140.824 12.3112C141.301 11.84 141.543 11.2349 141.543 10.5012C141.543 9.76753 141.301 9.16247 140.824 8.69129C140.351 8.2201 139.763 7.98385 139.075 7.98385C138.381 7.98385 137.799 8.2201 137.321 8.69129C136.843 9.16247 136.601 9.76753 136.601 10.5012C136.601 11.2349 136.843 11.84 137.321 12.3112Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M143.555 13.6473V7.35254H144.563L147.698 12.2482H147.734L147.698 11.038V7.35254H148.527V13.6473H147.662L144.379 8.51016H144.342L144.379 9.72554V13.6473H143.555Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M135.552 22.8402C133.026 22.8402 130.963 24.7171 130.963 27.3067C130.963 29.8752 133.026 31.7718 135.552 31.7718C138.084 31.7718 140.147 29.8752 140.147 27.3067C140.147 24.7171 138.084 22.8402 135.552 22.8402ZM135.552 30.0131C134.166 30.0131 132.974 28.8961 132.974 27.3067C132.974 25.6962 134.166 24.599 135.552 24.599C136.938 24.599 138.136 25.6962 138.136 27.3067C138.136 28.8961 136.938 30.0131 135.552 30.0131ZM125.538 22.8402C123.007 22.8402 120.949 24.7171 120.949 27.3067C120.949 29.8752 123.007 31.7718 125.538 31.7718C128.068 31.7718 130.128 29.8752 130.128 27.3067C130.128 24.7171 128.068 22.8402 125.538 22.8402ZM125.538 30.0131C124.151 30.0131 122.955 28.8961 122.955 27.3067C122.955 25.6962 124.151 24.599 125.538 24.599C126.924 24.599 128.117 25.6962 128.117 27.3067C128.117 28.8961 126.924 30.0131 125.538 30.0131ZM113.623 24.2092V26.1071H118.264C118.129 27.1676 117.766 27.9472 117.209 28.4906C116.532 29.1468 115.476 29.8752 113.623 29.8752C110.766 29.8752 108.529 27.6243 108.529 24.8352C108.529 22.0462 110.766 19.7952 113.623 19.7952C115.167 19.7952 116.291 20.3846 117.12 21.1484L118.49 19.811C117.33 18.7295 115.787 17.8987 113.623 17.8987C109.705 17.8987 106.413 21.0106 106.413 24.8352C106.413 28.6599 109.705 31.7718 113.623 31.7718C115.74 31.7718 117.33 31.0946 118.58 29.8241C119.861 28.5732 120.261 26.8145 120.261 25.3944C120.261 24.9534 120.223 24.5478 120.156 24.2092H113.623ZM162.348 25.6805C161.97 24.6817 160.805 22.8402 158.431 22.8402C156.078 22.8402 154.12 24.6502 154.12 27.3067C154.12 29.8083 156.058 31.7718 158.657 31.7718C160.758 31.7718 161.97 30.521 162.469 29.7926L160.91 28.778C160.39 29.5209 159.681 30.0131 158.657 30.0131C157.639 30.0131 156.909 29.5576 156.441 28.6599L162.559 26.1884L162.348 25.6805ZM156.111 27.1676C156.058 25.4456 157.48 24.5636 158.499 24.5636C159.298 24.5636 159.975 24.9534 160.201 25.5112L156.111 27.1676ZM151.138 31.5001H153.149V18.3751H151.138V31.5001ZM147.845 23.8351H147.777C147.326 23.3127 146.464 22.8402 145.372 22.8402C143.082 22.8402 140.987 24.8037 140.987 27.3211C140.987 29.8241 143.082 31.7718 145.372 31.7718C146.464 31.7718 147.326 31.2954 147.777 30.7572H147.845V31.3977C147.845 33.1053 146.91 34.0227 145.403 34.0227C144.175 34.0227 143.412 33.1565 143.098 32.4281L141.349 33.1407C141.853 34.3246 143.188 35.7815 145.403 35.7815C147.761 35.7815 149.751 34.427 149.751 31.1313V23.1119H147.845V23.8351ZM145.544 30.0131C144.158 30.0131 142.998 28.8804 142.998 27.3211C142.998 25.7474 144.158 24.599 145.544 24.599C146.91 24.599 147.987 25.7474 147.987 27.3211C147.987 28.8804 146.91 30.0131 145.544 30.0131ZM171.764 18.3751H166.954V31.5001H168.959V26.5271H171.764C173.991 26.5271 176.176 24.9534 176.176 22.4504C176.176 19.9488 173.986 18.3751 171.764 18.3751ZM171.816 24.7014H168.959V20.2008H171.816C173.314 20.2008 174.169 21.4149 174.169 22.4504C174.169 23.4663 173.314 24.7014 171.816 24.7014ZM184.215 22.8153C182.765 22.8153 181.258 23.4401 180.639 24.8247L182.419 25.5532C182.802 24.8247 183.506 24.5885 184.251 24.5885C185.291 24.5885 186.347 25.1988 186.363 26.2764V26.4142C186 26.2094 185.223 25.9062 184.267 25.9062C182.35 25.9062 180.397 26.9366 180.397 28.8594C180.397 30.6181 181.967 31.7508 183.732 31.7508C185.082 31.7508 185.826 31.1562 186.294 30.4646H186.363V31.4791H188.3V26.4444C188.3 24.1173 186.52 22.8153 184.215 22.8153ZM183.973 30.0078C183.317 30.0078 182.402 29.6902 182.402 28.8961C182.402 27.8802 183.542 27.4904 184.529 27.4904C185.412 27.4904 185.826 27.6807 186.363 27.9314C186.206 29.1468 185.134 30.0078 183.973 30.0078ZM195.358 23.1027L193.052 28.7924H192.984L190.6 23.1027H188.437L192.018 31.0539L189.975 35.4783H192.071L197.589 23.1027H195.358ZM177.278 31.5001H179.289V18.3751H177.278V31.5001Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4987 7.9137C73.1828 8.23657 73 8.73926 73 9.39026V32.611C73 33.262 73.1828 33.7647 73.4987 34.0876L73.5767 34.1584L86.9041 21.1516V20.8444L73.5767 7.83757L73.4987 7.9137Z",
    fill: "url(#paint0_linear_97_2357)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3428 25.4937L86.9053 21.1558V20.8487L91.3482 16.5109L91.4477 16.5673L96.7093 19.4903C98.2109 20.3198 98.2109 21.6848 96.7093 22.5195L91.4477 25.4372L91.3428 25.4937Z",
    fill: "url(#paint1_linear_97_2357)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4488 25.437L86.9064 21.0021L73.501 34.0917C73.9997 34.6035 74.813 34.6652 75.7379 34.1534L91.4488 25.437Z",
    fill: "url(#paint2_linear_97_2357)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4488 16.5651L75.7379 7.84875C74.813 7.34213 73.9997 7.40381 73.501 7.91569L86.9064 21L91.4488 16.5651Z",
    fill: "url(#paint3_linear_97_2357)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_97_2357",
    x1: 85.7208,
    y1: 32.8528,
    x2: 68.1043,
    y2: 14.8095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_97_2357",
    x1: 98.6646,
    y1: 21.0008,
    x2: 72.6422,
    y2: 21.0008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_97_2357",
    x1: 88.9787,
    y1: 18.5912,
    x2: 65.0894,
    y2: -5.87703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_97_2357",
    x1: 70.1266,
    y1: 41.815,
    x2: 80.7942,
    y2: 30.8889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.6071523a5ce49e65494923869f2cc7c8.svg";
export { ForwardRef as ReactComponent };